import { Card } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import _ from "lodash";
import React from "react";

import {
  MultipleChoiceIcon,
  WorkflowIcon,
} from "../../../components/icons/themes/windows10";
import {
  destinationKeyToSlugMap,
  saasDestinations,
} from "../../../destinations/destinations";
import { DestinationKey } from "../../../destinations/types";
import { TransformationIntention } from "../../types";

const useStyles = makeStyles((theme) => ({
  intentionSelection: {
    width: 300,
    height: 300,
  },
  intentionIcon: {
    width: 48,
    height: 48,
  },
}));

const NewTransformationPageStep1Intention: React.FC<{
  intentionName: string;
  intentionKey: TransformationIntention;
  onClick: () => void;
  isActive: boolean;
  notSelected: boolean;
  Icon: React.ForwardRefExoticComponent<any>;
  children: React.ReactNode;
}> = ({
  intentionName,
  intentionKey,
  onClick,
  isActive,
  notSelected,
  Icon,
  children,
}) => {
  const classes = useStyles();

  return (
    <Card
      onClick={onClick}
      className={clsx(
        classes.intentionSelection,
        !isActive && !notSelected && "opacity-75",
        !isActive && notSelected && "opacity-50",
        "hover:opacity-100 hover:border cursor-pointer mx-2 flex flex-col justify-start hover:shadow-xl",
        "items-center relative"
      )}
    >
      <CardContent className="flex flex-col h-full">
        <div className="p-2 rounded bg-green-100 text-green-800 inline-block mb-2 flex justify-center items-center">
          <Icon className="mr-2 text-2xl" />
          <div className="font-bolder text-lg">{intentionName}</div>
        </div>
        <div className="mt-4">{children}</div>
      </CardContent>
    </Card>
  );
};

export const NewTransformationPageStep1: React.FC<{
  intention?: TransformationIntention | null;
  setIntention: (intention: TransformationIntention) => void;
}> = ({ intention, setIntention }) => {
  const classes = useStyles();

  const advertisingDestinations = _.chain(saasDestinations)
    .filter((d) => d.type === "advertising" && d.hasEventMapping)
    .orderBy((d) => Object.keys(destinationKeyToSlugMap).indexOf(d.key), "desc")
    .value();

  return (
    <div className="flex justify-center items-stretch mt-8">
      <NewTransformationPageStep1Intention
        key="standardEvent"
        intentionKey="standardEvent"
        intentionName="Standard Event"
        isActive={!!intention && intention === "standardEvent"}
        notSelected={!!intention && intention !== "standardEvent"}
        onClick={() => {
          setIntention("standardEvent");
        }}
        Icon={WorkflowIcon}
      >
        <div className="text-lg font-bolder text-gray-700">Use Cases:</div>
        <ul className="list-disc pl-5 mt-2 text-md text-grey-700">
          <li>Rename events & properties to fit a destination&apos;s schema</li>
        </ul>
        <div className="w-full absolute left-0 bottom-0 py-5 px-5 flex justify-between text-xl">
          {advertisingDestinations.map((d) => {
            const Logo = d.logoSquare;
            return <Logo key={d.key} />;
          })}
        </div>
      </NewTransformationPageStep1Intention>
      <NewTransformationPageStep1Intention
        key="fixBadData"
        intentionKey="fixBadData"
        intentionName="Fix Bad Data"
        isActive={!!intention && intention === "fixBadData"}
        notSelected={!!intention && intention !== "fixBadData"}
        onClick={() => {
          setIntention("fixBadData");
        }}
        Icon={MultipleChoiceIcon}
      >
        <div className="text-lg font-bolder text-gray-700">Use Cases:</div>
        <ul className="list-disc pl-5 mt-2 text-md text-grey-700">
          <li>Fix misnamed events</li>
          <li>Rename events and properties to match historical data</li>
          <li>Block sensitive data from going to a destination</li>
        </ul>
      </NewTransformationPageStep1Intention>
    </div>
  );
};
